import React, { useEffect } from "react";
import { Form, Select, Typography } from "antd";

import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

// Mirrors the server enum it.polimi.lode.model.building.ArtisticDamageKind.
const ARTISTIC_DAMAGE_KINDS = [
    { value: "DETACHMENT",         label: "Detachment" },
    { value: "CRACK",              label: "Crack" },
    { value: "WATER_INFILTRATION", label: "Water infiltration" },
    { value: "SMOKE_SOOT",         label: "Smoke / soot" },
    { value: "CORROSION",          label: "Corrosion" },
    { value: "COLOR_LOSS",         label: "Color loss" },
    { value: "STRUCTURAL_FAILURE", label: "Structural failure" },
    { value: "OTHER",              label: "Other" },
];

// Mirrors the server enum it.polimi.lode.model.DamageLevel.
const DAMAGE_LEVELS = [
    { value: "LOW",    label: "Low" },
    { value: "MEDIUM", label: "Medium" },
    { value: "HIGH",   label: "High" },
];

const DamageArtisticGoodForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    const formItemLayout = {
        labelCol: { sm: { span: 8 } },
        wrapperCol: { sm: { span: 16 } },
    };

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                artisticKind: props.record.damage.artisticKind,
                damageLevel: props.record.damage.damageLevel,
            });
        }
    }, [props.record.damage, form]);

    const onValuesChange = (changedValues) => {
        form.validateFields(Object.keys(changedValues));
    };

    const onFieldsChange = () => {
        if (!isEditMode) return;
        const fieldsError = form.getFieldsError();
        const valid = fieldsError.every(field => !field.errors || field.errors.length === 0);

        const values = form.getFieldsValue();
        const newDamage = { ...props.record };
        // Server's DamageApi.convertToEntity routes by this discriminator + the
        // parent component class (ArtisticGood) — both must agree.
        newDamage.damage.damageDiscriminator = "ARTISTIC_GOOD";
        newDamage.damage.artisticKind = elvis(values.artisticKind);
        newDamage.damage.damageLevel = elvis(values.damageLevel);
        newDamage.valid = valid;
        props.parentCallback(newDamage);
    };

    return (
        <Form
            {...formItemLayout}
            form={form}
            className="details_form"
            onValuesChange={onValuesChange}
            onFieldsChange={onFieldsChange}
        >
            <Title className="details_form_header"
                title="Damages details"
                subTitle="Artistic good"
            />
            <Form.Item label="Kind of damage" name="artisticKind">
                <Select allowClear disabled={!isEditMode}>
                    {ARTISTIC_DAMAGE_KINDS.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Severity" name="damageLevel">
                <Select allowClear disabled={!isEditMode}>
                    {DAMAGE_LEVELS.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Select>
            </Form.Item>
        </Form>
    );
};

export default DamageArtisticGoodForm;
